window.Quello = window.Quello || {};
window.Quello.stateGeoData = {
  colorado: {
    code: "co",
    name: "Colorado",
    center: { lat: 39.1433, lng: -105.9424 },
    cities: [
      { name: "Denver", lat: 39.7392, lng: -104.9903 },
      { name: "Aspen", lat: 39.1911, lng: -106.8175 },
      { name: "Colorado Springs", lat: 38.8339, lng: -104.8214 },
      { name: "Telluride", lat: 37.9375, lng: -107.8123 },
      { name: "Boulder", lat: 40.015, lng: -105.2705 },
    ],
  },
  ohio: {
    code: "oh",
    name: "Ohio",
    center: { lat: 40.1879, lng: -83.0684 },
    cities: [
      { name: "Columbus", lat: 39.9612, lng: -82.9988 },
      { name: "Cleveland", lat: 41.4993, lng: -81.6944 },
      { name: "Cincinnati", lat: 39.1031, lng: -84.512 },
    ],
  },
  iowa: {
    code: "ia",
    name: "Iowa",
    center: { lat: 41.7808, lng: -92.372 },
    cities: [
      { name: "Des Moines", lat: 41.5868, lng: -93.625 },
      { name: "Davenport", lat: 41.5236, lng: -90.5776 },
      { name: "Ames", lat: 42.0347, lng: -93.6199 },
      { name: "Cedar Rapids", lat: 41.9779, lng: -91.6656 },
    ],
  },
  kansas: {
    code: "ks",
    name: "Kansas",
    center: { lat: 38.1847, lng: -97.3249 },
    cities: [
      { name: "Kansas City", lat: 39.1142, lng: -94.6275 },
      { name: "Wichita", lat: 37.6872, lng: -97.3301 },
      { name: "Dodge City", lat: 37.7528, lng: -100.0171 },
    ],
  },
  wyoming: {
    code: "wy",
    name: "Wyoming",
    center: { lat: 43.5459, lng: -107.5259 },
    cities: [
      { name: "Casper", lat: 42.8666, lng: -106.3131 },
      { name: "Gillette", lat: 44.2911, lng: -105.5022 },
      { name: "Jackson", lat: 43.4799, lng: -110.7624 },
    ],
  },
  washington: {
    code: "wa",
    name: "Washington",
    center: { lat: 47.5744, lng: -121.0374 },
    cities: [
      { name: "Seattle", lat: 47.6062, lng: -122.3321 },
      { name: "Spokane", lat: 47.6588, lng: -117.426 },
      { name: "Bellingham", lat: 48.7519, lng: -122.4787 },
      { name: "Tacoma", lat: 47.2529, lng: -122.4443 },
      { name: "Yakima", lat: 46.6021, lng: -120.5059 },
    ],
  },
  idaho: {
    code: "id",
    name: "Idaho",
    center: { lat: 43.3498, lng: -115.3976 },
    cities: [
      { name: "Boise", lat: 43.615, lng: -116.2023 },
      { name: "Nampa", lat: 43.5407, lng: -116.5635 },
      { name: "Twin Falls", lat: 42.5629, lng: -114.4609 },
      { name: "Ketchum", lat: 43.6807, lng: -114.3637 },
    ],
  },
  oregon: {
    code: "or",
    name: "Oregon",
    center: { lat: 44.0449, lng: -122.226 },
    cities: [
      { name: "Portland", lat: 45.5152, lng: -122.6784 },
      { name: "Redmond", lat: 44.2726, lng: -121.1739 },
      { name: "Eugene", lat: 44.0521, lng: -123.0868 },
      { name: "Bend", lat: 44.0582, lng: -121.3153 },
      { name: "Medford", lat: 42.3265, lng: -122.8756 },
    ],
  },
  nebraska: {
    code: "ne",
    name: "Nebraska",
    center: { lat: 41.0701, lng: -97.7991 },
    cities: [
      { name: "Omaha", lat: 41.2565, lng: -95.9345 },
      { name: "Lincoln", lat: 40.8136, lng: -96.7026 },
      { name: "North Platte", lat: 41.1403, lng: -100.7601 },
    ],
  },
  utah: {
    code: "ut",
    name: "Utah",
    center: { lat: 39.3637, lng: -112.3726 },
    cities: [
      { name: "Salt Lake City", lat: 40.7608, lng: -111.891 },
      { name: "Provo", lat: 40.2338, lng: -111.6585 },
      { name: "St. George", lat: 37.0965, lng: -113.5684 },
    ],
  },
  arizona: {
    code: "az",
    name: "Arizona",
    center: { lat: 33.8523, lng: -111.7921 },
    cities: [
      { name: "Phoenix", lat: 33.4484, lng: -112.074 },
      { name: "Flagstaff", lat: 35.1983, lng: -111.6513 },
      { name: "Prescott", lat: 34.54, lng: -112.4685 },
      { name: "Tucson", lat: 32.2226, lng: -110.9747 },
    ],
  },
  new_mexico: {
    code: "nm",
    name: "New Mexico",
    center: { lat: 35.7262, lng: -106.0538 },
    cities: [
      { name: "Albuquerque", lat: 35.0844, lng: -106.6504 },
      { name: "Santa Fe", lat: 35.687, lng: -105.9378 },
      { name: "Taos", lat: 36.4072, lng: -105.5731 },
    ],
  },
  minnesota: {
    code: "mn",
    name: "Minnesota",
    center: { lat: 45.7691, lng: -93.1641 },
    cities: [
      { name: "Minneapolis", lat: 44.9778, lng: -93.265 },
      { name: "Saint Paul", lat: 44.9537, lng: -93.09 },
      { name: "Brainerd", lat: 46.358, lng: -94.2008 },
      { name: "Duluth", lat: 46.7867, lng: -92.1005 },
    ],
  },
  north_dakota: {
    code: "nd",
    name: "North Dakota",
    center: { lat: 47.306, lng: -99.6233 },
    cities: [
      { name: "Fargo", lat: 46.8772, lng: -96.7898 },
      { name: "Minot", lat: 48.2325, lng: -101.2963 },
      { name: "Bismarck", lat: 46.8083, lng: -100.7837 },
    ],
  },
  montana: {
    code: "mt",
    name: "Montana",
    center: { lat: 46.1108, lng: -111.1792 },
    cities: [
      { name: "Missoula", lat: 46.8721, lng: -113.994 },
      { name: "Billings", lat: 45.7833, lng: -108.5007 },
      { name: "Bozeman", lat: 45.677, lng: -111.0429 },
    ],
  },
  texas: {
    code: "tx",
    name: "Texas",
    center: { lat: 30.9354, lng: -97.6273 },
    cities: [
      { name: "Austin", lat: 30.2672, lng: -97.7431 },
      { name: "Dallas", lat: 32.7767, lng: -96.797 },
      { name: "Houston", lat: 29.7604, lng: -95.3698 },
      { name: "Abilene", lat: 32.4487, lng: -99.7331 },
      { name: "San Antonio", lat: 29.4241, lng: -98.4936 },
    ],
  },
  missouri: {
    code: "mo",
    name: "Missouri",
    center: { lat: 38.4718, lng: -92.6011 },
    cities: [
      { name: "Kansas City", lat: 39.0997, lng: -94.5786 },
      { name: "St. Louis", lat: 38.627, lng: -90.1994 },
      { name: "Springfield", lat: 37.2089, lng: -93.2923 },
      { name: "Columbia", lat: 38.9517, lng: -92.3341 },
    ],
  },
  michigan: {
    code: "mi",
    name: "Michigan",
    center: { lat: 42.5252, lng: -84.1523 },
    cities: [
      { name: "Detroit", lat: 42.3314, lng: -83.0458 },
      { name: "Grand Rapids", lat: 42.9634, lng: -85.6681 },
      { name: "Ann Arbor", lat: 42.2808, lng: -83.743 },
    ],
  },
  south_dakota: {
    code: "sd",
    name: "South Dakota",
    center: { lat: 43.6856, lng: -101.1455 },
    cities: [
      { name: "Sioux Falls", lat: 43.5446, lng: -96.7311 },
      { name: "Rapid City", lat: 44.0805, lng: -103.231 },
      { name: "Hot Springs", lat: 43.4316, lng: -103.4744 },
    ],
  },
  indiana: {
    code: "in",
    name: "Indiana",
    center: { lat: 40.1074, lng: -86.1748 },
    cities: [
      { name: "Indianapolis", lat: 39.7684, lng: -86.1581 },
      { name: "Fort Wayne", lat: 41.0793, lng: -85.1394 },
      { name: "Bloomington", lat: 39.1653, lng: -86.5264 },
      { name: "Lafayette", lat: 40.4167, lng: -86.8753 },
    ],
  },
  oklahoma: {
    code: "ok",
    name: "Oklahoma",
    center: { lat: 35.74, lng: -97.0018 },
    cities: [
      { name: "Oklahoma City", lat: 35.4676, lng: -97.5164 },
      { name: "Tulsa", lat: 36.154, lng: -95.9928 },
      { name: "Stillwater", lat: 36.1156, lng: -97.0584 },
      { name: "Norman", lat: 35.2226, lng: -97.4395 },
    ],
  },
  illinois: {
    code: "il",
    name: "Illinois",
    center: { lat: 41.1561, lng: -88.9907 },
    cities: [
      { name: "Chicago", lat: 41.8781, lng: -87.6298 },
      { name: "Rockford", lat: 42.2711, lng: -89.0937 },
      { name: "Peoria", lat: 40.6936, lng: -89.589 },
      { name: "Springfield", lat: 39.7817, lng: -89.6501 },
    ],
  },
  wisconsin: {
    code: "wi",
    name: "Wisconsin",
    center: { lat: 43.8592, lng: -89.2049 },
    cities: [
      { name: "Milwaukee", lat: 43.0389, lng: -87.9065 },
      { name: "Madison", lat: 43.0731, lng: -89.4012 },
      { name: "Green Bay", lat: 44.5133, lng: -88.0133 },
      { name: "Eau Claire", lat: 44.8113, lng: -91.4985 },
    ],
  },
  virginia: {
    code: "va",
    name: "Virginia",
    center: { lat: 37.3184, lng: -77.0442 },
    cities: [
      { name: "Norfolk", lat: 36.8508, lng: -76.2859 },
      { name: "Virginia Beach", lat: 36.8529, lng: -75.978 },
      { name: "Richmond", lat: 37.5407, lng: -77.436 },
      { name: "Charlottesville", lat: 38.0293, lng: -78.4767 },
    ],
  },
  south_carolina: {
    code: "sc",
    name: "South Carolina",
    center: { lat: 33.8766, lng: -81.12 },
    cities: [
      { name: "Charleston", lat: 32.7765, lng: -79.9311 },
      { name: "Columbia", lat: 34.0007, lng: -81.0348 },
      { name: "Greenville", lat: 34.8526, lng: -82.394 },
    ],
  },
  georgia: {
    code: "ga",
    name: "Georgia",
    center: { lat: 32.1656, lng: -82.9001 },
    cities: [
      { name: "Atlanta", lat: 33.749, lng: -84.388 },
      { name: "Augusta", lat: 33.4735, lng: -82.0105 },
      { name: "Savannah", lat: 32.0809, lng: -81.0912 },
      { name: "Macon", lat: 32.8407, lng: -83.6324 },
      { name: "Albany", lat: 31.5785, lng: -84.1557 },
    ],
  },
  tennessee: {
    code: "tn",
    name: "Tennessee",
    center: { lat: 35.5175, lng: -86.5804 },
    cities: [
      { name: "Nashville", lat: 36.1627, lng: -86.7816 },
      { name: "Knoxville", lat: 35.9606, lng: -83.9207 },
      { name: "Memphis", lat: 35.1495, lng: -90.049 },
      { name: "Chattanooga", lat: 35.0456, lng: -85.3097 },
    ],
  },
  florida: {
    code: "fl",
    name: "Florida",
    center: { lat: 27.8333, lng: -81.5833 },
    cities: [
      { name: "Miami", lat: 25.7617, lng: -80.1918 },
      { name: "Orlando", lat: 28.5383, lng: -81.3792 },
      { name: "Tampa", lat: 27.9506, lng: -82.4572 },
      { name: "Jacksonville", lat: 30.3322, lng: -81.6557 },
    ],
  },
  louisiana: {
    code: "la",
    name: "Louisiana",
    center: { lat: 31.1695, lng: -91.8678 },
    cities: [
      { name: "New Orleans", lat: 29.9511, lng: -90.0715 },
      { name: "Baton Rouge", lat: 30.4515, lng: -91.1871 },
      { name: "Lake Charles", lat: 30.2266, lng: -93.2174 },
      { name: "Alexandria", lat: 31.3113, lng: -92.4451 },
      { name: "Shreveport", lat: 32.5252, lng: -93.7502 },
    ],
  },
  kentucky: {
    code: "ky",
    name: "Kentucky",
    center: { lat: 37.8393, lng: -85.7585 },
    cities: [
      { name: "Louisville", lat: 38.2527, lng: -85.7585 },
      { name: "Lexington", lat: 38.0406, lng: -84.5037 },
      { name: "Bowling Green", lat: 36.9685, lng: -86.4808 },
    ],
  },
  pennsylvania: {
    code: "pa",
    name: "Pennsylvania",
    center: { lat: 40.9946, lng: -77.6047 },
    cities: [
      { name: "Philadelphia", lat: 39.9526, lng: -75.1652 },
      { name: "Pittsburgh", lat: 40.4406, lng: -79.9959 },
      { name: "Erie", lat: 42.1292, lng: -80.0851 },
      { name: "Harrisburg", lat: 40.2732, lng: -76.8867 },
    ],
  }
};

window.dispatchEvent(new CustomEvent("quello:stateGeoData:ready", {
  detail: { stateGeoData: window.Quello.stateGeoData },
}));
